import script from "./Achieve.vue?vue&type=script&setup=true&lang=ts"
export * from "./Achieve.vue?vue&type=script&setup=true&lang=ts"

import "./Achieve.vue?vue&type=style&index=0&id=3c70d3b6&lang=scss&scoped=true"

import exportComponent from "/var/www/digital-card-solution-limited/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c70d3b6"]])

export default __exports__